const endpoint = "https://us-central1-comodin-c9ec5.cloudfunctions.net/app/api/enviar-intencion"

export const createOrderIntention = async (orderIntention) => {
    let data = orderIntention
    let res = await fetch_function(data)
    // console.log(res)
    return res.id
}

export const updateOrderIntention = async (data_to_update) => {
    await fetch_function(data_to_update)
}

const fetch_function = async (data) => {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };
    try {
      const response = await fetch(endpoint, config);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Fetch operation failed:", error);
    }
  };
